import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import RedesSociales from "../../../components/RedesSociales";
import useFooter from "../../../hooks/useFooter";

// íconos, logos, imágenes
import brand from "../../../assets/images/brand/Tensolite-Isologotipo-con-bajada.svg";
import logoSitenso from "../../../assets/images/logo_sitenso_footer.png";
import logoAfip from "../../../assets/images/DATAWEB.jpg";
import logoAabh from "../../../assets/images/pie-aabh.svg";

const FooterReplicaList = () => {
  const { footerCats } = useFooter();

  function gtag_report_conversion(url) {
    var callback = function () {
      if (typeof url != "undefined") {
        window.open(url, "_blank");
      }
    };
    callback("event", "conversion", {
      send_to: "AW-936555276/n6xiCLOq4bYBEIzmyr4D"
    });
    return false;
  }

  return (
    <Fragment>
      <footer>
        <div className="container">
          <div className="row">
            {/* col BRAND */}
            <div className="col-12 col-sm-12 col-md-4 col-lg-3 mb-3" id="navs__footer-brand">
              <div className="row">
                <div className="col-6 col-md-12">
                  <img src={brand} alt="Logo Tensolite" />
                  {/*<img src={brandV} alt="Logo Tensolite" className="navs__brand-vertical" />*/}
                  <div className="d-flex contenedor-logos">
                    <div className="w-50">
                      <img
                        decoding="async"
                        alt="imagen aabh"
                        src={logoAabh}
                        className="logo_aabh mt-3"
                      ></img>
                    </div>
                    <div className="w-50">
                      <a
                        href="https://serviciosweb.afip.gob.ar/clavefiscal/qr/response.aspx?qr=5ROdQx5lI5dnGRqNpwyOtQ,,"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          decoding="async"
                          alt="Data Fiscal"
                          src={logoAfip}
                          className="logo_afip float-end"
                        ></img>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* col  items */}
            <div className="col-12 col-sm-12 col-md-8 col-lg-9 mb-3">
              <div className="row">
                {/* col TAGS */}
                <section id="navs__footer-tags" className="col-12 col-sm-6 col-md-6 col-lg-8">
                  <div className="row">
                    {footerCats?.map((cat) => (
                      <div className="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-3" key={cat._id}>
                        <h2>{cat.category}</h2>
                        <ul>
                          {cat.items?.map((item) => (
                            <li key={item._id}>
                              <Link to={item.link} reloadDocument>
                                {item.label}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                    {/**in de tags */}
                  </div>
                </section>
                {/* col REDES SOCIALES */}
                <section id="navs__footer-redes" className="col-12 col-sm-6 col-md-6 col-lg-4">
                  <header>
                    <h1>Seguinos</h1>
                  </header>
                  <RedesSociales />
                  <article className="mt-3">
                    <h2>
                      Suscribete a nuestro <strong>newsletter</strong>
                    </h2>
                    <button className="settings_button-pleno bg-p-secondary my-3 d-flex justify-content-center button-footer">
                      <a
                        onClick={() =>
                          gtag_report_conversion("https://mailchi.mp/tensolite/newsletters")
                        }
                        href="https://mailchi.mp/tensolite/newsletters"
                        target="__blank"
                        rel="noopener"
                      >
                        SUSCRIBIRSE
                      </a>
                    </button>
                  </article>
                </section>
              </div>
              {/* col PRODUCTOS */}
              <div className="row"></div>
            </div>
          </div>
        </div>
        <section className="text-center sitenso-footer">
          <p>
            Powered by {" "}
            <a href="https://sitenso.com/" target="__blank" rel="noopener" title="Sitenso">
              <img
                className="logo-sitenso"
                src={logoSitenso}
                alt="Sitenso"
                aria-label="Conoce a Sitenso"
                title="Sitenso"
              />
            </a>
          </p>
        </section>
      </footer>
    </Fragment>
  );
};

export default FooterReplicaList;
